module.exports = __webpack_public_path__ + "img/maison.51929352.svg";